<template>
    <button v-if="start_date && !hide_toggle_btn" type="button" class=" btn-primary1"
    :class="{ 'btn-disabled': !validateGroupAndAttachment }" :disabled="!validateGroupAndAttachment"
    @click="this.show = true">
        {{ confirmButtonLabel }}
    </button>



    <!-- Modal -->
    <div class="modal-backdrop-container" v-show="this.show">
        <div class="modal-msg-confirm" role="dialog">
            <div class="custom-modal" role="document">
                <div class="custom-modal-content" style="max-width: 700px;">
                    <div class="modal-header">
                    <h1 class="modal-title fs-5">{{ testFields.title }}</h1>
                    <button type="button" class="btn-close" @click="this.show = false"></button>
                    </div>
                    <div class="modal-body">
                        <div class="msg-confirm">
                             <svg width="150" height="150" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 48 L38 71 L85 21"  stroke="#28A745" stroke-width="16"  stroke-linecap="round"  stroke-linejoin="round" fill="none"/>
                            </svg>  
                            <h4 class="confirm-message mb-3">{{ config['confirm_web_rdv'] == 1 ? "Demande de rendez-vous" : "Confirmer le rendez-vous" }}<br /></h4>        
                            <h5 v-if="config['confirm_web_rdv'] == 1" class="confirm-message" style="color: #FBBC00;">Cliquer sur confirmer pour envoyer votre demande. Notre service la traitera, et vous recevrez un mail de confirmation dans les plus brefs délais.</h5>
                        </div>
                        <div class="container">
                            <div v-if="!is_updating" class="row row-cols-3 mb-3">
                                <button v-if="this.stripeEnabled" class="col btn btn-payment btn-stripe" @click="stripePayment" style="width: 100%;">
                                    Payer avec Stripe
                                </button>
                                <button v-if="this.systempayEnabled" class="col btn btn-payment btn-systempay" @click="systempayPayment" style="width: 100%; background-color: #01b0cd;">
                                    Payer via VISA/MASTERCARD
                                </button>
                                <button v-if="this.paymentEnabled && !force_payment && !this.is_paid" class="col btn btn-payment btn-create-rdv" @click="confirm" style="width: 100%;">
                                    Payer sur place
                                </button>
                            </div>
                            <div v-if="!is_updating && this.paypalEnabled" id="paypal_container" class="column mb-3" ref="paypal"></div>                                                    

                            <div class="d-flex gap-3 justify-content-center">
                                <button v-if="start_date && (!this.paymentEnabled || this.is_paid || is_updating)" type="button" class=" btn-primary1" @click="confirm"> {{ testFields.textConfirmationButton }} </button>
                                <button type="button" class="btn-confirm1" @click="cancel">{{ testFields.textCancelButton }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="modal-backdrop"></div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { toast } from "bulma-toast";
    import { BookingStore } from "../Stores/BookingStore";
    import { createPaypalBnt, stripeHandlePayment, handlePayment } from '../../../payment';
    import { BookingUtility } from "../Utilities/booking_utility";
    import SystempaySmartForm from './SystempaySmartForm.vue';
import { Utilities } from "../Utilities/utilities";

    export default {
        components: { SystempaySmartForm },
        name: 'ConfirmationPopUp',
        props: [
            "rdv_data",
            "rdvs_data",
            "client_infos",
            "withAuth",
            "autoSelectNext",
            "price",
            "duration",
            'group_size',
            "prestations",
            "prestations_ids",
            "location",
            "agenda",
            "start_date",
            "config",
            'fo_config',
            'attendees',
            "participants",
            "attachment",
            'hide_toggle_btn',
            'toggle_from_outside',
            'show_modal',
            ],
        emits: ['showSystempayForm'],
        data() {
            return {
                show: false,
                // date: '2025-06-12 12:20',
                testFields: {
                    title : 'Confirmez votre rendez-vous',
                    description : 'Veuillez confirmer votre rendez-vous',
                    textConfirmationButton : 'Confirmer',
                    textCancelButton : 'Annuler'
                },
                prestations_fields: [],
                participants_fields: [],
                is_loading: false,
                rdv_requested: false,
                // participants: [],
                selectedParticipant: null,
                error_message: null,
                store: BookingStore,
                localRdvData: null,
                selectedPaymentMethod: null, // 'stripe' | 'systempay' | 'paypal'
                systempayHandlerRegistered: false,      
                showSystempayForm: false,
                systempayFormToken: null
            }
        },
        computed: {
            confirmButtonLabel() {
                if (this.rdv_data.rdv_id) return 'Confirmer';
                
                const presta = this.prestations[0] || {};
                const needed = this.group_size - 1;
                const current = this.participants.length;
                const isGroupPresta = (this.group_size ?? 1) > 1;
                const allowAttachForAttendees = presta.allow_use_attach_for_attendees;
                const forceParticipants = presta.forced_to_edit_participants;
                const forceAttachment = presta.force_attachment;
                const hasValidParticipants = current === needed;
                const hasValidAttachment = !!this.attachment;

                // CAS : Prestation de groupe
                if (isGroupPresta) {
                    // RÈGLE ABSOLUE : Si force_attachment == 1 ET PJ manquante
                    if ((presta.allow_attachment || allowAttachForAttendees) && forceAttachment && !hasValidAttachment) {
                        // Si participants aussi manquants
                        if (!hasValidParticipants && forceParticipants) {
                            if (current < needed) {
                                return `Ajoutez ${needed - current} participant(s) et une pièce jointe`;
                            }
                            if (current > needed) {
                                return `Retirez ${current - needed} participant(s) et ajoutez une pièce jointe`;
                            }
                        }
                        // Participants OK mais PJ manquante
                        return 'Ajoutez une pièce jointe';
                    }

                    // Si "Saisie ou pièce jointe" activé (et PJ pas forcée ou PJ présente)
                    if ((presta.allow_attachment || allowAttachForAttendees) && forceParticipants) {
                        if (presta.allow_attachment && !allowAttachForAttendees) {
                            if (current < needed) {
                                return `Ajoutez ${needed - current} participant(s)`;
                            }
                        }
                        if (hasValidParticipants) return 'Confirmer';
                        if (hasValidAttachment) return 'Confirmer';

                        if (current < needed) {
                            return `Ajoutez ${needed - current} participant(s) ou une pièce jointe`;
                        }
                    }

                    // Participants manquants
                    if (current < needed && forceParticipants) {
                        if (allowAttachForAttendees && !hasValidAttachment) {
                            return `Ajoutez ${needed - current} participant(s) ou une pièce jointe`;
                        }
                        return `Ajoutez ${needed - current} participant(s)`;
                    }

                    // Trop de participants
                    if (current > needed) {
                        return `Retirez ${current - needed} participant(s)`;
                    }

                    return 'Confirmer';
                }

                // CAS : Prestation NON groupe
                if (presta.allow_attachment && forceAttachment && !hasValidAttachment) {
                    return 'Ajoutez une pièce jointe';
                }

                return 'Confirmer';
            },
            validateGroupAndAttachment() {
                if (this.rdv_data.rdv_id) return true;

                const presta = this.prestations[0] || {};
                const forceParticipants = presta.forced_to_edit_participants;
                const forceAttachment = presta.force_attachment;
                const allowAttachForAttendees = presta.allow_use_attach_for_attendees;
                const isGroupPresta = (this.group_size ?? 1) > 1;

                const expectedGroupSize = this.group_size - 1;
                const hasValidParticipants = this.participants.length === expectedGroupSize;
                const hasValidAttachment = !!this.attachment;
                
                // Prestation NON groupe (MULTIPLE_RDV == 0)
                if (this.config['MULTIPLE_RDV'] == 0 && !isGroupPresta) {
                    if ((presta.allow_attachment || allowAttachForAttendees) && forceAttachment) return hasValidAttachment;
                    return true;
                }

                // Prestation de groupe
                if (isGroupPresta) {
                    console.log('Prestation de groupe', {
                        allow_attachment: presta.allow_attachment,
                        forceAttachment,
                        forceParticipants,
                        allowAttachForAttendees,
                        hasValidParticipants,
                        hasValidAttachment
                    });

                    // RÈGLE ABSOLUE : Si force_attachment == 1, la PJ est OBLIGATOIRE
                    if ((presta.allow_attachment ||  allowAttachForAttendees) && forceAttachment && !hasValidAttachment) {
                        console.log('❌ PJ obligatoire manquante');
                        return false;
                    }

                    // Si "Saisie ou pièce jointe" est activé → L'un OU l'autre suffit
                    if (allowAttachForAttendees && forceParticipants) {
                        console.log('Saisie OU pièce jointe');
                        // Si force_attachment, on a déjà vérifié ci-dessus
                        // Sinon, participants OU attachment suffisent
                        if ((presta.allow_attachment ||  allowAttachForAttendees) && forceAttachment) {
                            // PJ obligatoire + participants valides
                            return hasValidAttachment && hasValidParticipants;
                        }
                        return hasValidParticipants || hasValidAttachment;
                    }
                    if (forceParticipants && presta.allow_attachment && !allowAttachForAttendees && !forceAttachment) {
                        console.log('Saisie obligatoire mais pièce jointe non');
                        // Participants obligatoires + PJ 
                        return hasValidParticipants;
                    }

                    // Si seulement participants forcés
                    if (forceParticipants) {
                        console.log('Seulement participants forcés');
                        // Participants obligatoires + PJ si force_attachment
                        if ((presta.allow_attachment ||  allowAttachForAttendees) && forceAttachment) {
                            return hasValidParticipants && hasValidAttachment;
                        }
                        return hasValidParticipants;
                    }

                    // Si seulement pièce jointe forcée (déjà vérifié ci-dessus)
                    if ((presta.allow_attachment || allowAttachForAttendees) && forceAttachment) {
                        console.log('Seulement pièce jointe forcée');
                        return hasValidAttachment;
                    }
                    //Aucune contrainte → toujours valide
                    return true;
                }

                // CAS 3 : MULTIPLE_RDV == 1 (sans groupe)
                if (this.config['MULTIPLE_RDV'] == 1 && !isGroupPresta) {
                    if ((presta.allow_attachment || allowAttachForAttendees) && forceAttachment) return hasValidAttachment;
                    if (forceParticipants) return hasValidParticipants;
                    return true;
                }

                // Fallback : Valide par défaut
                return true;
            },

            edit_participants() {
                if(this.group_size < 2 || this.participants_fields.length < 1){
                    return false;
                }

                for (let i = 0; i < this.prestations.length; i++) {
                    if (this.prestations[i].is_group == 1 && this.prestations[i].allow_subgroup == 1
                        && (this.prestations[i].edit_participants == 1 || this.prestations[i].forced_to_edit_participants == 1)) {
                        return true;
                    }
                }
                return false;
            },
            paymentEnabled: function(){
                if (this.is_updating) {
                    return false;
                }
                console.log('Confirmation popup paymentEnabled',BookingUtility.rdv_price(this.prestations, BookingStore.get_groupe_size()),this.prestations,BookingStore.get_groupe_size());
                
                return this.config.enable_paiement != 0 &&  0 < + BookingUtility.rdv_price(this.prestations, BookingStore.get_groupe_size());
            },
            paypalEnabled: function() {
                return this.paymentEnabled && window.paypal && !this.is_paid && !this.is_updating;
            },
            stripeEnabled: function(){
                return this.paymentEnabled && window.stripe && !this.is_paid && !this.is_updating;
            },
            systempayEnabled: function() {
                return this.paymentEnabled && !this.is_paid && !this.is_updating;
            },
            is_paid() {
                return this.is_updating && this.rdv_data.paid;
            },
            is_updating() {
                return this.rdv_data.rdv_id ? true : false;
                // if (this.config['MULTIPLE_RDV'] == 1 && !this.store.rdvToModify) return false;
                //     return this.rdv_data?.rdv_id ? true : false;
            },
            force_payment() {
                for (let i = 0; i < this.prestations.length; i++) {
                    if (this.prestations[i].force_payment == 1) {
                        return true;
                    }
                }
                return false;
            },
            hasAttachment() {
                return this.attachment && (
                    this.attachment instanceof File || 
                    (this.attachment.isExisting && this.attachment.path)
                );
            },
            user() {
                return this.$page.props.auth.user?.client?.[0]
            },
        },
        methods: {
            set_show(value){
                this.show = value;
            },
            cancel() {
                // Add Logic
                this.show = false
            },
            confirm() { 
                // Add Logic
                console.log(this.date)
                this.show = false

                if(this.config['MULTIPLE_RDV'] == 1 && !this.store.rdvToModify){
                    this.create_multiple_rdvs();
                }else{
                    this.createRdv();
                }

                
            },
            cancelRdv(rdvToCancel) {
                // console.log('emit received', rdvToCancel)
                axios.delete('/rdv/'+ rdvToCancel).then(response => {
                    toast({
                        message: 'Votre rendez-vous a bien été annulé.',
                        type: 'is-success',
                        duration: 3000,
                        pauseOnHover: true
                    })
                }).catch(err => {
                    toast({
                        message: err?.response?.data?.message || 'Une erreur a empeché la suppression du rendez-vous.',
                        type: 'is-danger',
                        duration: 5000,
                        pauseOnHover: true
                    })
                })
            },
            updateRdvData(newData) {
                console.log('📝 ConfirmationPopUp - updateRdvData appelé:', newData);
                this.localRdvData = { ...newData };
            },
            async createRdv() {

                  console.log("multiple rdv rrrrrrrrrrrrrrrrrr",this.config['MULTIPLE_RDV'] );
                 // Rediriger vers create_multiple_rdvs si MULTIPLE_RDV
                // if (this.config['MULTIPLE_RDV'] == 1 && !this.store.rdvToModify) {
                //     return this.create_multiple_rdvs();
                // }
             
                if(this.edit_participants && this.prestations[0].forced_to_edit_participants == 1 && this.subgroup_out_of_range){
                    this.error_message = "Le nombre de participants doit être de "+(this.group_size - 1);
                    if(this.prestations[0]?.allow_use_attach_for_attendees == 1){
                        if(!this.attachment) {
                            this.error_message += " ou joindre un fichier à la place";
                            return false;
                        }
                    }else{
                        return false;
                    }
                }
                
                if(!this.rdv_data.rdv_id && !this.validateAttachment()){
                    this.error_message = "Une pièce jointe est requise";
                    return false;
                }
                
                if(!this.rdv_data.rdv_id && this.showExtraFields){
                    let result = this.set_extra_fields_values_to_rdv_data();
                    if(!result){
                        return false;
                    }
                }
                
                this.error_message = null;
                this.is_loading = true;
                const rdvDataToSend = this.store.rdvToModify ?? (this.localRdvData || this.rdv_data);
                rdvDataToSend.client = this.client_infos;

                if (this.participants && this.participants.length > 0) {
                    rdvDataToSend.participants = this.participants;
                }
                // Ajouter les participants au payload
                if (rdvDataToSend.participants && rdvDataToSend.participants.length > 0) {
                    // Calculer depuis participants
                    if (rdvDataToSend.participants[0]?.attendees) {
                        const attendees = JSON.parse(rdvDataToSend.participants[0]?.attendees || '[]');
                        rdvDataToSend.group_size = (attendees?.length ?? 0) + 1;
                    }
                } else {
                    // Valeur par défaut
                    rdvDataToSend.group_size = this.group_size || 1;
                }
                try {
                    let response;
                    let successMessage = '';

                    if (rdvDataToSend.rdv_id) {
                        // Cas de l'iframe : demander à Safari d'accorder l'accès aux cookies
                        const granted = await Utilities.ensureCookieAccess();
                        let token = null;
                        if (!granted) {
                            // Récupérer un token temporaire
                            const tokenResponse = await axios.get('/client/form/token');
                            token = tokenResponse.data;
                        }

                        let data = this.get_axios_params(rdvDataToSend, token ? '/token' : '');
                        console.log('ConfirmationPopup createRdv',data,rdvDataToSend);

                        response = await axios(data,{ headers: { 'X-Form-Token': token } });
                        successMessage = response.data?.message || 'Rendez-vous modifié avec succès';
                        // console.log('Données RDV mises à jour');
                        if (this.attachment && !this.attachment.isExisting) {
                            // console.log('📎 Upload du NOUVEAU fichier après modification...');
                            
                            await this.uploadAttachmentToRdv(
                                rdvDataToSend.rdv_id,
                                rdvDataToSend.client_id || this.client_infos.client_id,
                                null
                            );
                            successMessage = 'Rendez-vous et pièce jointe modifiés avec succès';
                        }
                    // CAS CRÉATION
                    } else {
                        // Cas de l'iframe : demander à Safari d'accorder l'accès aux cookies
                        const granted = await Utilities.ensureCookieAccess();
                        let token = null;
                        if (!granted) {
                            // Récupérer un token temporaire
                            const tokenResponse = await axios.get('/client/form/token');
                            token = tokenResponse.data;
                        }

                        // console.log('🆕 MODE CRÉATION - Nouveau RDV');
                        let data = this.get_axios_params(rdvDataToSend, token ? '/token' : '');
                        response = await axios(data,{ headers: { 'X-Form-Token': token } });
                        successMessage = response.data?.message || 'Rendez-vous créé avec succès.';
                        // console.log('✅ RDV créé avec ID:', response.data.rdv_id);
                        
                        // Upload attachment après création si nécessaire
                        if (this.attachment && response.data.rdv_id) {
                            const result = await this.uploadAttachmentToRdv(
                                response.data.rdv_id, 
                                response.data.client_id, 
                                response.data?.confirm_message
                            );
                            if(result.status == 200){
                                successMessage += " Pièce jointe attachée !"
                            }else{
                                successMessage += " ⚠️ Pièce jointe non attachée !"
                            }
                        }
                    }
                    
                    // console.log('Confirmation popup create rdv ',response.data,rdvDataToSend);
                    this.is_loading = false;
                    if (response.data?.rdv_id) {
                        toast({
                                message: successMessage,
                                type: "is-success",
                                duration: 5000,
                                pauseOnHover: true,
                        });
                    }

                    // Attendre un peu pour que l'utilisateur voie le toast
                    await new Promise(resolve => setTimeout(resolve, 200));
                    // Redirection APRÈS l'upload
                    if (this.config['confirm_web_rdv'] != 1){
                        if(this.redirected){
                            if(this.fo_config['redirect_url']){
                                let data = {...this.fo_config['redirect_params'], ...response.data};
                                data['rdv_id'] = response.data?.rdv_id;
                                data['reservation_statut'] = 'VALIDER';
                                
                                const formResponse = await axios.post('form', data);
                                this.redirect('rdv_body', formResponse.data);
                            } else {
                                if (this.withAuth) {
                                    this.$inertia.get('/account');
                                } else {
                                    this.$inertia.get("/ressources");
                                }
                            }
                        } else {
                            if (this.store.rdvToModify) {
                                // this.cancelRdv(this.store.rdvToModify.rdv_id)
                                this.store.rdvToModify = null;
                            }
                            if (this.withAuth) {
                                this.$inertia.get('/account');
                            } else {
                                this.$inertia.get('/ressources');
                                // window.location.href = '/ressources';
                            }
                            // window.location.redirect(this.withAuth ? '/account' : '/home')
                        }
                    } else {
                        this.rdv_requested = true;
                        // window.location.reload();
                        if (this.withAuth) {
                            this.$inertia.get('/account');
                        } else {
                            // this.$inertia.get('');
                            window.location.href = '/ressources';
                        }
                    }
                } catch (err) {
                    // Gestion spécifique du conflit 409
                    if (err.response?.status === 409) {
                        this.$emit('show-conflict-error', err.response.data);
                        toast({
                            message: "Le rendez-vous a été modifié par ailleurs. Veuillez recharger la page.",
                            type: "is-warning",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                    } else {
                        toast({
                            message: err?.response?.data?.message || "Le rendez-vous n'a pas pu être créé.",
                            type: "is-danger",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                    }
                    this.is_loading = false;
                }
            },

            async uploadAttachmentToRdv(rdv_id, client_id, confirm_msg) {
                console.log('📎 uploadAttachmentToRdv appelé:', {
                    rdv_id,
                    client_id,
                    attachment: this.attachment?.name
                });
                if (!this.attachment || !rdv_id || !client_id) {
                    // console.log('❌ IDs or Attachment not found');
                    return;
                }
                if (!(this.attachment instanceof File)) {
                    // console.log('⚠️ Attachment is not a File instance, converting...');
                    if (this.attachment.isExisting) {
                        // console.log('ℹ️ Fichier existant, pas besoin d\'upload');
                        return;
                    }
                }
                
                const form_data = new FormData();
                form_data.append('rdv_id', rdv_id);
                form_data.append('client_id', client_id);
                form_data.append('file_extension', this.attachment.name.split('.').pop());
                form_data.append('attachment', this.attachment);
                
                if(confirm_msg) form_data.append('confirm_message', confirm_msg);

                try {
                    const attach_response = await axios.post('rdv/attach', form_data, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        timeout: 30000
                    });
                    
                    // console.log(`✅ Attachment uploaded for RDV ${rdv_id}`);
                    return attach_response;
                } catch (error) {
                    // console.error(`❌ Failed to upload attachment for RDV ${rdv_id}:`, error);
                    toast({
                        message: error || `La pièce jointe n'a pas pu être chargée pour le rendez-vous ${rdv_id}!`,
                        type: "is-warning",
                        duration: 5000,
                        pauseOnHover: true,
                    });
                    
                    throw error;
                }
            },

            async create_multiple_rdvs(){
                console.log('create_multiple_rdvs', this.rdvs_data);

                console.log('KEYS envoyés:', Object.keys(this.rdvs_data));
                console.log('DATA complète:', JSON.stringify(this.set_user_into_rdvs_data(this.rdvs_data)));
                
                try {
                    const response = await axios({
                        method: 'POST',
                        url: window.location.origin + (this.withAuth ? '/rdvs' : '/rdvs/without_auth'),
                        data: this.set_user_into_rdvs_data(this.rdvs_data)
                    });
                    
                    const first = response.data[0];
                    console.log('rdv_id', first.rdv_id, 'client_id', first.client_id);

                    // Attendre l'upload avant de rediriger
                    if (this.attachment) {
                        try{
                            await this.uploadAttachmentToRdv(first.rdv_id, first.client_id, first.confirm_message);
                        }catch (uploadError) {
                        console.error('Erreur upload pièce jointe:', uploadError);
                       
                    }
                    }
                        
                    
                    this.is_loading = false;
                    
                    if(this.config['confirm_web_rdv'] != 1){
                        if (this.withAuth) {
                            this.$inertia.get('/account');
                        } else {
                            window.location.href = '/ressources';
                        }
                    } else {
                        this.rdv_requested = true;
                        if (this.withAuth) {
                            this.$inertia.get('/account');
                        } else {
                            window.location.href = '/ressources';
                        }
                        // window.location.reload(); 
                    }
                } catch (error) {
                    console.error('Erreur lors de la création multiple de RDVs:', error);
                    this.is_loading = false;
                    toast({
                        message: error?.response?.data?.message || "Les rendez-vous n'ont pas pu être créés.",
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                    });
                }
            },
            // Set the user taking rdv, and the one he is taking it for if not set
            set_user_into_rdvs_data(rdvs_data){
                let rdvs = {};
                let keys = Object.keys(rdvs_data);
                for (const key of keys) {
                    rdvs[key] = {
                        ...rdvs_data[key],
                        ...{by_client: BookingStore.get_user_infos() ?? this.user},
                        ...{for_client: rdvs_data[key].for_client ?? (BookingStore.get_user_infos() ?? this.user)}
                    }
                }
                console.log('confirmationpopup set_user_into_rdvs_data',rdvs);
                
                return rdvs;
            },
            validateAttachment(){
                if(this.prestations[0].force_attachment == 1 ){
                    return  this.hasAttachment;
                }
                return true;
            },
            validateDynamiqueFields(bloc_id, presta_fields){
                // if (this.is_loading) return false

                let fields = document.querySelectorAll(`#${bloc_id} [field_name]`);

                let data = {}
                for (let field of fields) {
                    if (field.getAttribute('type') === 'checkbox' && !field.checked) continue;
                    let field_name = field.getAttribute('field_name');
                    let elt = data[field_name]||[];
                    if (field.value) elt.push(field.value);
                    data[field_name] = elt;
                }
                for (let key in data) {
                    let field = presta_fields.find(field => field.internal_col_name === key);
                    if (field.data_type !== "checkbox") data[key] = data[key].toString();
                    if (field.required && (!data[key] || (data[key]+"").trim() == "")) {
                        let field_name = field.name ? field.name?.toLowerCase() : null;
                        this.error_message =
                            field_name ?
                            `Le champ "${field_name}" est obligatoire.` :
                            "Merci de renseigner tous les champs obligatoires."
                        return false
                    }
                    if(field.data_type === 'date'){
                        let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                        if (result){
                            data[key] = `${result[3]}/${result[2]}/${result[1]}`
                        }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                        }else{
                            let field_name = field.name.toLowerCase()
                            this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                            return false
                        }
                    }
                }
                return data;
            },
            setAttachment($event) {
                const target = $event.target;
                let size = (target.files[0].size/1024)/1024;
                if (target && target.files && size <= 2) {
                    this.attachment = target.files[0];
                    document.querySelector('#attachment_size_msg').style.color = '#6c6387';

                    document.querySelector('#attachment').style.color = 'inherit';
                    document.querySelector('#file_label').remove();
                }else{
                    document.querySelector('#attachment_size_msg').style.color = 'red';
                    document.querySelector('#attachment').value = null;
                }
            },
            get_axios_params(rdvDataToSend = null, pathEnd = ''){
                const data = rdvDataToSend || this.rdv_data;
                const requestData = {
                    ...data,
                    group_size: data?.rdv_id != null ? data.group_size : (this.group_size|| data.group_size)
                };

                if (data?.rdv_id != null && this.attachment && !this.attachment.isExisting) {
                    requestData.has_new_attachment = true; // Flag pour le backend
                }
                console.log('📤 RequestData avec group_size:', data.group_size);
                
                return data?.rdv_id != null ? {
                    method: 'PUT',
                    url: "/rdv/" + data.rdv_id + pathEnd,
                    data: requestData
                } : {
                    method: 'POST',
                    url: window.location.origin + (this.withAuth ? "/rdv/add_rdv" : "/rdv/without_auth") + pathEnd,
                    data: requestData
                };
            },
            set_extra_fields_values_to_rdv_data(){
                let data = this.validateDynamiqueFields('rdv_extra_fields_bloc', this.prestations_fields);
                if(data){
                    this.error_message = null;
                }else{
                    return false;
                }
                for (const field of this.prestations_fields) {
                    this.rdv_data[field.internal_col_name] = document.getElementById('rdv-field-'+field.internal_col_name).value;
                }
                return true
            }, 
            async stripePayment(){
                this.selectedPaymentMethod = 'stripe';
                if(this.edit_participants && this.prestations[0].forced_to_edit_participants == 1 && this.subgroup_out_of_range){
                    this.error_message = "Le nombre de participants doit être de "+(this.group_size - 1);
                    if(this.prestations[0]?.allow_use_attach_for_attendees == 1){
                        if(!this.attachment) {
                            this.error_message += " ou joindre un fichier à la place";
                            return false;
                        }
                    }else{
                        return false;
                    }
                }
                if(!this.validateAttachment()){
                    this.error_message = "Une pièce jointe est requise";
                    return false;
                }
                if(this.showExtraFields){
                    let result = this.set_extra_fields_values_to_rdv_data();
                    if(!result){
                        return false;
                    }
                }
                
                this.error_message = null;
                this.is_loading = true;

                try {
                    // Créer le RDV avec toutes les données
                    // Si le rdv à modifier présent dans le store, l'envoyer
                    const rdvDataToSend = this.store.rdvToModify ?? (this.localRdvData || this.rdv_data);
                    rdvDataToSend.client = this.client_infos;
                    
                    if (this.participants && this.participants.length > 0) {
                        rdvDataToSend.participants = this.participants;
                    }

                    // Cas de l'iframe : demander à Safari d'accorder l'accès aux cookies
                    const granted = await Utilities.ensureCookieAccess();
                    let token = null;
                    if (!granted) {
                        // Récupérer un token temporaire
                        const tokenResponse = await axios.get('/client/form/token');
                        token = tokenResponse.data;
                    }

                    const stripeResponse = await handlePayment(rdvDataToSend, 'stripe', this.withAuth, token);
                    
                    // Upload de la pièce jointe
                    if (this.attachment && !this.attachment.isExisting) {
                        if(stripeResponse.email != rdvDataToSend.client.email) {
                            console.warn('Confirmation popup attachment Client différent du client du rdv');
                        }
                        if(stripeResponse.rdv_id && stripeResponse.client_id){
                            await this.uploadAttachmentToRdv(stripeResponse.rdv_id, stripeResponse.client_id, null);
                        }
                    }

                    this.is_loading = false;
                    this.show = false;
                    
                    // Redirection vers Stripe
                    document.location = stripeResponse.url;
                    
                } catch (err) {
                    console.error('Erreur lors du paiement Stripe:', err);
                    this.is_loading = false;
                    toast({
                        message: err?.response?.data?.message || "Erreur lors de la création du paiement.",
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                    });
                }
            },

            // Modifier systempayPayment()
            async systempayPayment(){
                this.selectedPaymentMethod = 'systempay';
                if(this.edit_participants && this.prestations[0].forced_to_edit_participants == 1 && this.subgroup_out_of_range){
                    this.error_message = "Le nombre de participants doit être de "+(this.group_size - 1);
                    if(this.prestations[0]?.allow_use_attach_for_attendees == 1){
                        if(!this.attachment) {
                            this.error_message += " ou joindre un fichier à la place";
                            return false;
                        }
                    }else{
                        return false;
                    }
                }
                if(!this.validateAttachment()){
                    this.error_message = "Une pièce jointe est requise";
                    return false;
                }
                if(this.showExtraFields){
                    let result = this.set_extra_fields_values_to_rdv_data();
                    if(!result){
                        return false;
                    }
                }
                
                this.error_message = null;
                this.is_loading = true;

                try {
                    // Créer le RDV avec toutes les données
                    const rdvDataToSend = this.store.rdvToModify ?? (this.localRdvData || this.rdv_data);
                    rdvDataToSend.client = this.client_infos;
                    
                    if (this.participants && this.participants.length > 0) {
                        rdvDataToSend.participants = this.participants;
                    }
                    console.log('Confirmation popup Systempay ',rdvDataToSend);

                    // Cas de l'iframe : demander à Safari d'accorder l'accès aux cookies
                    const granted = await Utilities.ensureCookieAccess();
                    let token = null;
                    if (!granted) {
                        // Récupérer un token temporaire
                        const tokenResponse = await axios.get('/client/form/token');
                        token = tokenResponse.data;
                    }

                    const systempayResponse = await handlePayment(rdvDataToSend, 'systempay', this.withAuth,token);

                    // config systempay
                    let configSystempay = this.config?.systempay;
                    // console.log('Confirmationpopup systempayPayment',configSystempay);
                    if(typeof configSystempay?.options === 'object' && configSystempay?.options !== null){
                        // console.log('Confirmationpopup systempayPayment',configSystempay);
                        // Choix de l'api
                        if(configSystempay.options.api == 'REST'){
                            this.systempayShowSmartForm(systempayResponse);
                        }else{
                            this.systempayRedirect(systempayResponse);
                        }
                    }else{
                        throw new TypeError('Systempay non configuré');
                    }

                    // Upload de la pièce jointe
                    if (this.attachment && !this.attachment.isExisting) {
                        if(systempayResponse.email != rdvDataToSend.client.email) {
                            console.warn('Confirmation popup attachment Client différent du client du rdv');
                        }
                        if(systempayResponse.rdv_id && systempayResponse.client_id){
                            await this.uploadAttachmentToRdv(systempayResponse.rdv_id, systempayResponse.client_id, null);
                        }
                    }
                    
                } catch (err) {
                    console.error('Erreur lors du paiement SystemPay:', err);
                    this.is_loading = false;
                    toast({
                        message: err?.response?.data?.message || "Erreur lors de la création du paiement.",
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                    });
                }
            },

            // Paiement de systempay avec formulaire embarquée
            async systempayShowSmartForm(data) {
                if (this.showSystempayForm) return;

                this.systempayFormToken = data.formToken;
                this.showSystempayForm = true;
                this.$emit('showSystempayForm',this.systempayFormToken);
            },

            // Paiment par redirection
            async systempayRedirect(systempayResponse){
                this.is_loading = false;
                this.show = false;
                
                // Préparer et soumettre le formulaire
                let form = document.createElement("form");
                form.id = "systempay-form";
                form.action = systempayResponse.redirec_url;
                form.method = "post";
                
                Object.keys(systempayResponse).forEach(function (key) {
                    var input = document.createElement("input");
                    input.type = "text";
                    input.name = key;
                    input.value = systempayResponse[key];
                    form.appendChild(input);
                });
                
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            },

            // 3. Modifier create_paypal_btn() pour passer rdv_id
            create_paypal_btn(container){
                if (this.paypalEnabled) {
                    let self = this; // Garder référence au composant
                    
                    createPaypalBnt(
                        async () => {
                            // Préparer les données
                            const rdvDataToSend = this.store.rdvToModify ?? (this.localRdvData || this.rdv_data);
                            rdvDataToSend.client = this.client_infos;
                            
                            if (this.participants && this.participants.length > 0) {
                                rdvDataToSend.participants = this.participants;
                            }                            
                            // Retourner les données
                            return rdvDataToSend;
                        },
                        this.withAuth,
                        // onComplete
                        (rdvID, clientID, confirmMsg=null) => {
                            if (self.attachment && !self.attachment.isExisting) {
                                self.uploadAttachmentToRdv(rdvID,clientID,confirmMsg).then(() => {
                                    // Si upload attendre le retour de la requête
                                    if (this.withAuth) {
                                        console.log('withAuth');
                                        this.$inertia.get('/account');
                                    } else {
                                        console.log('without Auth');
                                        window.location.href = '/ressources';
                                    }
                                });
                            }else{
                                toast({
                                    message: "Paiement effectué avec succès. Vous recevrez un mail de confirmation.",
                                    type: "is-success",
                                    duration: 5000,
                                    pauseOnHover: true,
                                });
                                if (this.withAuth) {
                                    console.log('withAuth');
                                    this.$inertia.get('/account');
                                } else {
                                    console.log('without Auth');
                                    window.location.href = '/ressources';
                                }
                            }

                        },
                        () => {
                            // onCancelled
                            console.log('Paiement PayPal annulé');
                        },
                        () => {
                            this.selectedPaymentMethod = 'paypal';
                            // onBeforeCreateOrder - Validation
                            if (self.edit_participants && 
                                self.prestations[0].forced_to_edit_participants == 1 && 
                                self.subgroup_out_of_range) {
                                self.error_message = "Le nombre de participants doit être de " + (self.group_size - 1);
                                return false;
                            }
                            return true;
                        }
                    ).render(container);
                }
            }
        },
        mounted(){
            if(this.toggle_from_outside) this.show = this.show_modal;
            this.localRdvData = { ...this.rdv_data };
            console.log("ConfirmationPopup show popup", this.show, this.store.rdvToModify);
            if(this.$refs.paypal){
                this.create_paypal_btn(this.$refs.paypal);
            }

        },
        updated(){

        },
        watch: {
            show(value) {

            },
            show_modal(value){
                console.log("ConfirmationPopup show_modal", value);
                if(this.toggle_from_outside) this.show = value;
            },
            attachment: {
                handler(newVal, oldVal) {
                    console.log('📎 ConfirmationPopUp - Attachment prop changed:', {
                        old: oldVal?.name || 'null',
                        new: newVal?.name || 'null'
                    });
                },
                immediate: true,
                deep: true
            },
            rdv_data: {
                deep: true,
                handler(newVal) {
                    if (newVal && !this.localRdvData) {
                        this.localRdvData = { ...newVal };
                    }
                }
            }
        }
    }
</script>

<style scoped>
.modal-backdrop-container {
  position: fixed;
  top: 0; 
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  justify-content: center;
}

.modal-msg-confirm {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

.custom-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  /* width: 90%; */
  /* max-width: 500px; */
  z-index: 9999;
}

.custom-modal-content {
  padding: 1.5rem;
}

.btn-payment {
    min-width: fit-content;
    margin-bottom: 1rem;
    color: white;
    border-radius: 0.5rem;
}

.btn-stripe {
    background-color: #485fc7;
}

.btn-systempay{
    background-color: rgb(1, 176, 205);
}

.btn-create-rdv{
    background-color: #271c49;
}

.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

</style>
